<div
  class="flex h-10 rounded-md font-normal px-3 py-1.5 outline-1 -outline-offset-1 focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-primary"
  [ngClass]="
    disabled()
      ? 'bg-deactivated dark:bg-deactivated-darkmode text-on-deactivated dark:text-on-deactivated-darkmode outline-deactivated-outline dark:outline-deactivated-outline-darkmode'
      : 'bg-surface dark:bg-surface-darkmode text-on-surface dark:text-on-surface-darkmode outline-outline dark:outline-outline-darkmode'
  "
  uiPopover
  [anchor]="popover"
>
  <div class="flex-none flex items-center mr-2">
    <ng-icon name="heroCalendar" size="20" class="!block" />
  </div>
  <input
    type="text"
    [attr.id]="inputId()"
    [attr.placeholder]="placeholder()"
    [attr.autocomplete]="autocomplete()"
    [disabled]="disabled()"
    [value]="displayValue()"
    [uiDebounce]="debounceMs()"
    (input)="displayValue.set($any($event).target.value)"
    (debouncedInput)="onChangeInputValue($event)"
    (keyup)="touched.set(true)"
    class="flex-1 w-1 outline-none placeholder:text-on-surface-disabled dark:placeholder:text-on-surface-disabled-darkmode text-sm"
    (focus)="onInputFocus(popover)"
    (click)="popover.show()"
    (blur)="touched.set(true)"
  />
  @if (showClearButton()) {
    <div class="flex-none empty:hidden flex items-center ml-2">
      <ui-button
        slot="end"
        type="button"
        class="-mr-1.5"
        mode="ghost"
        size="small"
        [iconOnly]="true"
        (click)="onClickClear()"
      >
        <ng-icon name="heroXMark" size="20" class="!block" />
      </ui-button>
    </div>
  }
</div>

<ui-popover popover #popover>
  <div
    class="rounded-lg shadow-md bg-surface dark:bg-surface-darkmode border border-outline dark:border-outline-darkmode text-on-surface dark:text-on-surface-darkmode"
  >
    <ui-calendar-input [formField]="form.date" (fieldValueChange)="onChangeCalendarValue($event)" />
  </div>
</ui-popover>
